import { CabinetAppsConfigs } from "./cabinet/CabinetAppsConfigs";
import { ClientAppsConfigs } from "./client/ClientAppsConfigs";

export const appsConfigs = [...CabinetAppsConfigs, ...ClientAppsConfigs];
